export default function itemSearch() {
	const $conditions = document.getElementById("rental_index_conditions");
	if ($conditions !== null) {
		//全てのチェックボックス
		const regions = document.getElementsByName("acf_rental_condition_region");
		const times = document.getElementsByName("acf_rental_condition_time");
		const areas = document.getElementsByName("acf_rental_condition_area");
		const offers = document.getElementsByName("acf_rental_condition_offering");
		const alltargets = document.querySelectorAll(".search_target");
		//状態保存
		const conditions = {
			regions: [],
			times: [],
			areas: [],
			offers: [],
			category: [],
		};
		const defaultMessage = document.getElementById("num_results").innerText;
		//リセット
		const swapKeys = document.querySelectorAll(".swap_key");
		swapKeys.forEach(function (el) {
			el.addEventListener("click", function () {
				//フォームのリセット
				document.querySelectorAll("input[type='checkbox']").forEach(el => {
					el.checked = false;
				});
				Object.values(conditions).forEach(el => {
					el.length = 0;
				});
				// console.log(conditions);
				//

				document.getElementById("num_results").innerText = defaultMessage;

				const isActive = document.getElementsByClassName("active");
				console.log(isActive.length);
				if (isActive.length === 0) {
					document.querySelectorAll(".office").forEach(function (el) {
						el.classList.remove("_hide");
					});
					document.querySelectorAll(".apart").forEach(function (el) {
						el.classList.remove("_hide");
					});
				} else {
					const target = el.dataset.target;
					if (target.indexOf("apart") != -1) {
						document.querySelectorAll(".office").forEach(function (el) {
							el.classList.add("_hide");
						});
						document.querySelectorAll(".apart").forEach(function (el) {
							el.classList.remove("_hide");
						});
						conditions.category.push("apart");
					} else {
						document.querySelectorAll(".apart").forEach(function (el) {
							el.classList.add("_hide");
						});
						document.querySelectorAll(".office").forEach(function (el) {
							el.classList.remove("_hide");
						});
						conditions.category.push("office");
					}
				}
			});
		});

		regions.forEach((el, index) => {
			el.addEventListener("change", function () {
				conditions.regions = getChecked(regions);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});
		times.forEach((el, index) => {
			el.addEventListener("change", function () {
				conditions.times = getChecked(times);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});
		areas.forEach((el, index) => {
			el.addEventListener("change", function () {
				conditions.areas = getChecked(areas);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});
		offers.forEach((el, index) => {
			el.addEventListener("change", function () {
				conditions.offers = getChecked(offers);
				const choosed = checkAttibute();
				drawCards(choosed);
			});
		});

		function getChecked(arr = []) {
			const arrChecked = [];
			arr.forEach(el => {
				if (el.checked) {
					arrChecked.push(el.getAttribute("value"))
				}
			})
			// console.log(arrChecked);
			return arrChecked;
		}

		function checkAttibute() {
			//console.log(conditions);//選択内容
			///適合内容保存用
			const choosedTargets = {
				regions: [],
				times: [],
				areas: [],
				offers: [],
			}
			//製品一つ一つを条件チェック
			if (conditions.regions.length > 0) {
				const tmpArr = [];
				alltargets.forEach(target => {
					//Application 条件をチェック
					conditions.regions.forEach(region => {
						const hit = target.getAttribute("data-region");
						if (hit === region) {
							tmpArr.push(target);
						}
					})
				})
				choosedTargets.regions = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedTargets.regions = Array.from(alltargets);
			}

			if (conditions.times.length > 0) {
				const tmpArr = [];
				choosedTargets.regions.forEach(region => {
					conditions.times.forEach(time => {
						const hit = region.getAttribute("data-time");
						if (hit === time) {
							tmpArr.push(region);
						}
					})
				})
				choosedTargets.times = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedTargets.times = Array.from(choosedTargets.regions)
			}

			if (conditions.areas.length > 0) {
				const tmpArr = [];
				choosedTargets.times.forEach(time => {
					conditions.areas.forEach(area => {
						const hit = time.getAttribute("data-area");
						if (hit === area) {
							tmpArr.push(time);
						}
					})
				})
				choosedTargets.areas = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedTargets.areas = Array.from(choosedTargets.times);
			}

			if (conditions.offers.length > 0) {
				const tmpArr = [];
				choosedTargets.areas.forEach(area => {
					conditions.offers.forEach(offer => {
						const hit = area.getAttribute("data-offering");
						if (hit === offer) {
							tmpArr.push(area);
						}
					})
				})
				choosedTargets.offers = tmpArr.filter((x, i, self) => self.indexOf(x) === i);
			} else {
				choosedTargets.offers = Array.from(choosedTargets.areas);
			}
			const result = [];
			choosedTargets.offers.forEach(el => {
				console.log("filter", conditions.category[0]);
				if (el.classList.contains(conditions.category[0])) {
					result.push(el);
				}
			});
			return result;
		}

		function drawCards(choosedTargets) {
			alltargets.forEach(el => {
				el.classList.add("_hide");
			});
			choosedTargets.forEach(ch => {
				ch.classList.remove("_hide");
			});
			const result = document.getElementById("num_results");
			if (choosedTargets.length > 0) {
				result.innerHTML = `<strong>${choosedTargets.length}件</strong>あります。`;
			} else {
				result.innerHTML = `<span class="alert">条件を変更してください。</span>`;
			}
			const checkedNum = document.querySelectorAll('input[type="checkbox"]:checked').length;
			if (checkedNum === 0) {
				result.innerText = defaultMessage;
			}
		}
	}
}